import React from "react";
import "../css/AccessModePopup.css";
import globeIcon from "../assets/icons/ZeroPrivacy.png";
import lockIcon from "../assets/icons/FullPrivacy.png";
import { useDispatch, useSelector } from "react-redux";
import { togglePrivacyMode } from "../redux/privacySlice";
import { showSuccessToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";

const AccessModePopup = ({ setShowAccessMode }) => {
  const dispatch = useDispatch();
  const isFullPrivacy = useSelector((state) => state.privacy.isFullPrivacy);

  // const handleSelect = (mode) => {
  //   if (mode === "full" && !isFullPrivacy) {
  //     dispatch(togglePrivacyMode(true));
  //     showSuccessToast(TOAST_MESSAGES.PRIVACY_MODE_SELECTED_FULL);
  //     setShowAccessMode(false);
  //   } else if (mode === "zero" && isFullPrivacy) {
  //     dispatch(togglePrivacyMode(false));
  //     showSuccessToast(TOAST_MESSAGES.PRIVACY_MODE_SELECTED_ZERO);
  //     setShowAccessMode(false);
  //   }
  // };
  const handleSelect = (mode) => {
    // Full Privacy mode selected
    if (mode === "full") {
      if (!isFullPrivacy) {
        // Switch to Full Privacy
        dispatch(togglePrivacyMode(true));
        showSuccessToast(TOAST_MESSAGES.PRIVACY_MODE_SELECTED_FULL);
      }
      // ✅ Always close the popup (even if already active)
      setShowAccessMode(false);
    }

    // Zero Privacy mode selected
    else if (mode === "zero") {
      if (isFullPrivacy) {
        // Switch to Zero Privacy
        dispatch(togglePrivacyMode(false));
        showSuccessToast(TOAST_MESSAGES.PRIVACY_MODE_SELECTED_ZERO);
      }
      // ✅ Always close the popup (even if already active)
      setShowAccessMode(false);
    }
  };

  return (
    <div className="access-mode-overlay">
      <div className="access-mode-card">
        <h4 className="access-title mb-4 text-center">
          Select Your Access Mode
        </h4>

        <div className="access-options">
          {/* Zero Privacy */}
          <div
            className={`access-box border rounded-4 p-4 me-2 ${
              !isFullPrivacy ? "active-mode" : ""
            }`}
            onClick={() => handleSelect("zero")}
          >
            <div className="access-content">
              <p>
                <strong>Online Mode: No privacy mode</strong>
              </p>
              <p>Connected. Powerful. Real-time.</p>
              <ul>
                <li>
                  Access the latest AI models from OpenAI, Claude, Gemini, Meta,
                  and more.
                </li>
                <li>
                  Real-time responses powered by a smart cloud-based memory
                  (Pinecone).
                </li>
                <li>
                  Chat with anything: PDFs, videos, websites, YouTube links, and
                  more.
                </li>
                <li>Use voice chat for fast, hands-free conversations.</li>
                <li>Generate images and videos using advanced AI tools.</li>
                <li>Get live info: news, stock prices, weather, and more.</li>
                <li>
                  May share data with trusted third-party services to enable
                  features.
                </li>
              </ul>
            </div>

            <div className="access-bottom">
              <img src={globeIcon} alt="Globe" width="22" className="me-2" />
              <strong>Zero Privacy</strong>
            </div>
          </div>

          {/* Full Privacy */}
          <div
            className={`access-box border rounded-4 p-4 ms-2 full-privacy-box ${
              isFullPrivacy ? "active-mode" : ""
            }`}
            onClick={() => handleSelect("full")}
          >
            <div className="access-content">
              <p>
                <strong>Offline Mode: Full privacy</strong>
              </p>
              <p>Private. Secure. Focused.</p>
              <ul>
                <li>
                  All data stays on your local server — nothing is sent online.
                </li>
                <li>
                  Work offline with smart document chat and instant answers.
                </li>
                <li>
                  Analyse your documents securely with no internet needed.
                </li>
                <li>
                  Talk to your AI assistant locally — internet not required.
                </li>
                <li>
                  Privacy-focused setup ideal for secure or confidential
                  projects.
                </li>
                <li>Optional web access with strict privacy safeguards.</li>
                <li>Great for teams with strict data security needs.</li>
              </ul>
            </div>

            <div className="access-bottom full-bottom">
              <img
                src={lockIcon}
                alt="Lock"
                width="22"
                className="me-3 icon-image1"
              />
              <strong>Full Privacy</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessModePopup;
